import React from 'react';

class NotFound extends React.Component {
    render() {
        return(
            <section className='not-found'>
                <h2>404 -  Page not found</h2>
                <p>Try going back to the previous page.</p>
            </section>
        )
    }
}

export default NotFound